import {formateData, headers} from "./index";
import {applicationName} from "../utils";

export const messageNotificationList = (start, size, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/notice/list";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({start, size})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:message notification get message list error", error);
        callBack({});
    })
};

export const getAttachmentFiles = (id, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/notice/getAttachmentFile";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({'noticeId': id})
    }).then(response => response.json()).then(data => {
        callBack(data)
    }).catch((error) => {
        console.error("actionError:message notification get attachment files error", error);
    })
}

export const getNotificationById = (noticficationId,callback) => {
    let url = "/cm-sites-" + applicationName() + "/notification/getNotificationById";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({'notificationid': noticficationId})
    }).then(response => response.json()).then(data => {
        return callback(data.title);
    }).catch((error) => {
        console.error("actionError:message notification get notification error", error);
    })
}

export const updateReadStatus = (id) => {
    let url = "/cm-sites-" + applicationName() + "/notice/setReadMessageStatus"
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({'messageId': id})
    }).then(response => response.json()).then(data => {
        return data;
    }).catch((error) => {
        console.error("actionError:message notification update read status error", error);
    })
}
